import type { FindPageViewModel } from "src/http/types";

/**
 * Helper to determine if there are any search results
 */
export const hasSearchResults = (model: FindPageViewModel) => {
  const searchResultsCount = Object.values(model.eventGrids ?? {}).reduce(
    (acc, value) => acc + (value.totalCount ?? 0),
    0,
  );

  return searchResultsCount > 0;
};
